import { Icon } from '@branch-messenger/willow-ui'
import { Lock01 } from '@branch-messenger/willow-ui/icons'
import { FC } from 'react'

import { DropdownMenu, DropdownMenuItem } from '@/components/dropdown-menu'

import { DropdownActionButton } from '../styles'
import { AccountDetailDropdownActionProps } from '../types'

export const AccountDetailDropdownAction: FC<
  AccountDetailDropdownActionProps
> = ({ label = 'Manage', actions, disabled = false }) => {
  if (!actions || actions.length === 0) {
    return null
  }

  return (
    <DropdownMenu
      trigger={
        <DropdownActionButton
          color="secondary"
          variant="flat"
          iconLeft={disabled ? <Icon Icon={Lock01} /> : undefined}
        >
          {label}
        </DropdownActionButton>
      }
      disabled={disabled}
      showArrow={false}
    >
      {actions.map(action => {
        const { label, Icon: ActionIcon, onClick, ...restProps } = action
        return (
          <DropdownMenuItem
            key={label}
            title={label}
            onClick={onClick}
            showArrowRight={false}
            iconLeft={<Icon Icon={ActionIcon} />}
            {...restProps}
          >
            {label}
          </DropdownMenuItem>
        )
      })}
    </DropdownMenu>
  )
}
